import { render, staticRenderFns } from "./TarefaMobilidadeAssociacaoPage.vue?vue&type=template&id=21d09671"
import script from "./TarefaMobilidadeAssociacaoPage.vue?vue&type=script&lang=js"
export * from "./TarefaMobilidadeAssociacaoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports